import React from 'react';
import { motion } from 'framer-motion';

const testimonials = [
  {
    quote: "Abdul-Lateef is the reason I stopped dreading code review. He never just says what's wrong — he walks you through the why, then makes you fix it yourself so it actually sticks. Six months into being mentored by him, I was reviewing PRs on the Construction module on my own. That kind of jump doesn't happen without someone who actually takes the time.",
    name: "Ajibare Babajide",
    role: "Junior Backend Engineer, Carrotsuite",
  },
  {
    quote: "When you're coordinating jurors across dozens of countries with an awards deadline that cannot move, there's no room for a scoring system that behaves differently under load. Abdul-Lateef took what used to be a spreadsheet nightmare and turned it into something our adjudication team fully trusts — duplicate-safe submissions, full audit trails, and it held up cleanly through our busiest scoring window yet. He asks the right questions before he touches a line of code, which is rarer than it should be.",
    name: "Oseji Alexander",
    role: "Operations Lead, AFRIMA",
  },
  {
    quote: "What stood out working with Abdul-Lateef wasn't just that the platform worked — it was how much thought went into the edge cases we hadn't even raised yet. Compliance verification across trusts, shift generation, audit trails — the level of detail in how he handled our data model gave the whole team a lot more confidence going into rollout.",
    name: "James Whitfield",
    role: "Product Lead, MedRota (UK Healthcare Staffing)",
  },
  {
    quote: "Ask anyone on the team why Abdul-Lateef moved up as fast as he did and it's the same answer: attention to detail. He'll catch a GL mismatch three modules away from where he's supposed to be working, or notice an approval chain returning the wrong data before QA does. That's not something you can teach quickly — it's just how he works.",
    name: "Victor Oluwole",
    role: "Lead Engineer, Carrotsuite",
  },
];

const Testimonials = () => {
  return (
    <div className="py-4" id="testimonials">
      <div className="container2">
        <div className="sec-header mb-4 text-center">
          <h2 className="text-bold">Testimonials</h2>
          <p className="about-text text-muted">What People Say</p>
        </div>
        <motion.div
          className="testimonial-grid m-0"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          {testimonials.map((t, i) => (
            <div className="testimonial-card" key={i}>
              <p className="testimonial-quote">"{t.quote}"</p>
              <div>
                <p className="fw-bold m-0">{t.name}</p>
                <small className="text-muted">{t.role}</small>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default Testimonials;
